import { useEffect } from 'react';
import logo from 'assets/icons/logo.png';
import styles from 'styles/components/pages/common/LoginLayout.module.scss';

type TProps = {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
};

const LoginLayout = ({ children, title, subtitle }: TProps) => {
  const titleLines = title.split('\n');
  const subtitleLines = subtitle?.split('\n');

  useEffect(() => {
    document.body.style.overflowY = 'auto';

    return () => {
      document.body.style.overflowY = 'scroll';
    };
  }, []);

  return (
    <div className="pb40">
      <img src={logo} alt="logo" className={styles.logo} />
      <div className={styles.container}>
        {titleLines.map((line, index) => (
          <h1 key={index} className={styles.title}>
            {line}
          </h1>
        ))}
        {/* {subtitle && <p className={styles.text}>{subtitle}</p>} */}
        <div className={styles.subtitle_wrapper}>
          {subtitleLines?.map((line, index) => (
            <p key={index} className={styles.text}>
              {line}
            </p>
          ))}
        </div>
        {children}
      </div>
    </div>
  );
};

export default LoginLayout;
